import { heroImage } from "@/mocks/comics";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="妖精漫画追更入口的首屏插画，夜幕下的霓虹城市与眺望远方的少年"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-24 md:px-6 md:py-28">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-md">
            <i className="ri-flag-2-line text-sm text-accent-400"></i>
            妖精漫画 · 追更入口
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            最新话进度随时盯
            <br />
            你的连载追更神器
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            想看妖精漫画连载进度？这里就是追更入口。点开直达作品最新话，更新状态、
            连载进度一目了然。收藏你追的漫画，每次打开都能看到有没有新章节。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#updates"
              className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看最新更新
            </a>
            <a
              href="#featured"
              className="whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
            >
              浏览热门连载
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
            {[
              { num: "1200+", label: "在追连载" },
              { num: "2.6万+", label: "收藏追更" },
              { num: "每日", label: "进度更新" },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-heading text-2xl text-accent-300 md:text-3xl">{s.num}</p>
                <p className="mt-0.5 text-xs text-background-100/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}